import { render } from "./TheModal.vue?vue&type=template&id=6dc7a554&scoped=true"
import script from "./TheModal.vue?vue&type=script&lang=js"
export * from "./TheModal.vue?vue&type=script&lang=js"

import "./TheModal.vue?vue&type=style&index=0&id=6dc7a554&scoped=true&lang=css"

import exportComponent from "C:\\www\\webdesign - zelena\\vue\\dotacezelena-cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc7a554"]])

export default __exports__